import { brand } from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import { Device, from } from '@helpers/media';
import { h2, paragraph } from '@helpers/typography';
import FiltersStyles from '@stories/Components/Filtering/Filters/Filters.styles';
import styled from 'styled-components';
import SectionWrapper from '../../Misc/SectionWrapper/SectionWrapper';
const Container = styled(SectionWrapper) `
  ${setCssVar('fgColor', brand.black)};

  ${FiltersStyles.Container} {
    margin: 0 0 var(--sectionMargin);
  }
`;
const Inner = styled.div `
  @media ${from(Device.TabletLarge)} {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 32px
  }  
`;
const SideFilter = styled.div `
  @media ${from(Device.TabletLarge)} {
    grid-column: 1 / span 4;
    padding-right: 32px;
  }
`;
const Main = styled.div `
  grid-column: 1 / span 12;
  
  &[data-has-side-nav='true'] {
    @media ${from(Device.TabletLarge)} {
      grid-column: 5 / span 8;
    }
  }
  
`;
const Message = styled.p `
  ${paragraph}
  margin-top: var(--sectionMargin);
`;
const Loading = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.65);
  height: 100%;
  justify-content: center;
  width: 100%;
  z-index: 100;
`;
const CtaWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 84px;
`;
const ListTitle = styled.h2 `
  ${h2};
  color: ${cssVar('fgColor')};
  margin: 50px 0 30px;
`;
export default {
    Container,
    CtaWrapper,
    Inner,
    ListTitle,
    Loading,
    Main,
    Message,
    SideFilter,
};
